import { http, HttpResponse } from 'msw';
import { authMocks } from '../mocks';

export const signInHandler = http.post('*/users/auth/signin', () =>
  HttpResponse.json(authMocks.signInMock)
);

export const profileHandler = http.get('*/users/profile', () =>
  HttpResponse.json(authMocks.signInMock.User)
);

export const getBonuses = http.get('*/api/getBonuses.php*', () =>
  HttpResponse.json(authMocks.bonusesMock)
);
